import {USER_FEEDBACK_URL, USER_FEEDBACK_VERIFY} from './constants';
import useAxios from '../hooks/useAxios';

/**
 * Hook for interacting with the User Feedback API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useUserFeedbackApi = () => {
  const api = useAxios();

  /**
   * Posts user feedback to the API.
   *
   * @param {number} appExperienceRating - The rating for the app experience.
   * @param {string} appFeedbackDescription - The description of the app feedback.
   * @param {number} recommendationRating - The rating for the recommendation.
   * @param {boolean} promoEmail - Whether the user wants promotional emails.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  const postUserFeedback = (appExperienceRating, appFeedbackDescription, recommendationRating, promoEmail) =>
    api.post(USER_FEEDBACK_URL, {
      app_experience_rating: appExperienceRating,
      app_feedback_description: appFeedbackDescription,
      recommendation_rating: recommendationRating,
      promo_email: promoEmail,
    });

  /**
   * Checks if the user has already given feedback.
   *
   * @returns {Promise} A Promise that resolves with information about whether the user has given feedback.
   */
  const hasGivenFeedback = () => api.get(USER_FEEDBACK_VERIFY);

  return {
    postUserFeedback,
    hasGivenFeedback,
  };
};
